import React, { useState } from "react";
import { get } from "lodash";
import { Range } from "react-range";

import { getIcon } from "../../../helpers/icons";
import Text from "../../Text";
import Spacer from "../../Spacer";
import Tooltip from "../../Tooltip";

import style from './style.module.css';

const RangeSlider = ({ options = [], suffix = "", title, tooltip, input: { value, onChange }, tooltipIcon = "Question", showGridText = true, gridTexts = [] }) => {

    let initialIndex = options.findIndex(i => i === value);
    if (initialIndex === -1) {
        initialIndex = options.length - 1;
    }
    const [indexValue, setIndexValue] = useState([initialIndex]);

    return (
        <div className={`${style.range} ${style.wrap}`}>
            {
                title && (
                    <>
                        <div className={style.title}>
                            <Text tag="h5">{title}</Text>
                            {
                                tooltip && (
                                    <span className={style.tooltipIcon}>
                                        <i className={getIcon(tooltipIcon)}></i>
                                        <Tooltip className={style.tooltip}>{tooltip}</Tooltip>
                                    </span>
                                )
                            }
                        </div>
                        <Spacer />
                    </>
                )
            }
            <Range
                step={1}
                min={0}
                max={options.length - 1}
                values={indexValue}
                onChange={(value) => {
                    setIndexValue(value)
                }}
                onFinalChange={(newValues) => {
                    const selectedIndex = get(newValues, '0');
                    setIndexValue([selectedIndex]);
                    onChange(options[selectedIndex]);
                }}
                renderTrack={({ props, children }) => {
                    const { key, ...restProps } = props;
                    const fillPercent = options.length > 1 ? (indexValue / (options.length - 1)) * 100 : 0;

                    return (
                        <div key={key} {...restProps} className={style.barWrap}>
                            <div
                                className={style.bar}
                                style={{
                                    ...props.style,
                                    width: `${fillPercent}%`,
                                }}
                            />
                            {children}
                        </div>
                    );
                }}
                renderThumb={({ props }) => {
                    const { key, ...restProps } = props;
                    return (
                        <div
                            key={key}
                            {...restProps}
                            style={{ ...props.style }}
                            className={style.handle}
                        />
                    );
                }}
                renderMark={({ props, index }) => {
                    const { key, ...restProps } = props;
                    return (
                        <div key={props.key} style={{ ...props.style }}  {...restProps} className={style.tick}>
                            {showGridText === true &&
                                <div className={`${style.number}${index === indexValue ? " " + style.currentNum : ""}`}>
                                    {get(gridTexts, index) ? get(gridTexts, index) : <>{get(options, index)}{suffix}</>}
                                </div>
                            }
                        </div>
                    );
                }}
            />
        </div>
    );
};

export default RangeSlider;